import React from 'react';
const AllStars = ({ rating }) => {
  let arr = []
  for (let i = 1; i <= 5; i++) {
    if (+i <= rating) {
      arr.push(1)
    }
    else {
      if (+i <= rating + 0.5) {
        arr.push(2)
      }
      else {
        arr.push(3)
      }
    }
  }
  return (
    <div style={{ dispaly: 'flex', gap: 5 }}>{
      arr.map(ele => {
        if (ele === 1) {
          return <Star light={true} />
        }
        else if (ele === 2) {
          return <HalfStar />
        }
        else if (ele === 3) {
          return <Star light={false} />
        }
      })
    }</div>
  )
}
export default AllStars
const Star = ({ light }) => {
  const size = '16px';
  const fillColor = light ? '#03a56a' : '#676767';
  const strokeColor = 'black';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 5 }} width={size} height={size} viewBox="0 0 24 24">
      <path
        fill={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 1.697l3.364 7.9h8.636l-6.964 5.593 2.591 7.908L12 18.563l-6.627 4.543 2.591-7.908L.001 9.597h8.636L12 1.697z"
      />
    </svg>
  );
};
const HalfStar = () => {
  const size = '16px';
  const fillColor1 = '#676767';
  const fillColor2 = '#03a56a';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 5 }} width={size} height={size} viewBox="0 0 24 24">
      <path
        fill={fillColor1}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 1.697l3.364 7.9h8.636l-6.964 5.593 2.591 7.908L12 18.563z"
      />
      <path
        fill={fillColor2}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 1.697l-3.364 7.9H.001l6.964 5.593-2.591 7.908L12 18.563z"
      />
    </svg>
  );
};
